import { toast } from "react-toastify";
import { RenderPage } from "../../../../slices/common/reducer";
import { setfindData } from "../../../../slices/moduleAccess/findDataSlice";
import { setModuleAccess } from "../../../../slices/moduleAccess/moduleAccessSlice";
import rootReducer from "../../../../store";
import { showToast } from "../../../../common/Toaster/Toaster";
import api from "../../../../Utils/interface";

export const getAllModuleAccess = (organizationId) => {
  api
    .get(`/module/findAllModuleTreeMap`, {
      params: {
        organizationId: organizationId,
      },
    })
    .then((res) => {
      let arr = Object.values(res.data);

      rootReducer.dispatch(setModuleAccess(arr));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const moduleAccessUpdate = (updatedForm) => {
  api
    .post(`/module/updateModuleAccessMap`, updatedForm, {
      headers: {
        "Content-Type": "application/json", // Change to application/json
      },
    })
    .then((response) => {
      rootReducer.dispatch(RenderPage());
      showToast("Updated!", "success");
    })
    .catch((error) => {
      showToast("Error while updating application", "error");
    });
};

const solve = (data) => {
  const arr = [];
  arr.push({ id: -1, name: "" });
  data.map((item) => arr.push({ id: item.module_id, name: item.role_code }));
  return arr;
};

const createArray = (data) => {
  let newArray = [];
  data.map((item) => newArray.push(...item));
  newArray = newArray.filter((item) => item.access_flag === 1);
  return newArray;
};

export const getModuleRoleStatus = (setIsParent, setParentList) => {
  const params = {
    roleId: "-1",
  };

  api
    .get(`/module/getRoleModuleAccessMap`, { params })
    .then((res) => {
      let data = Object.values(res.data); // Assuming `res.data` contains the response data
      const newArr = createArray(data);
      const arr = solve(newArr);

      // Add access_flag to the state
      const updatedNewArr = newArr.map((item) => ({
        ...item,
        access_flag: item.access_flag || 0, // Assuming 0 means unchecked and 1 means checked
      }));

      setParentList(arr);
      setIsParent(updatedNewArr);
      rootReducer.dispatch(setfindData(updatedNewArr));
    })
    .catch((err) => {
      console.log(err);
    });
};
